import { render } from "./FpuiTableCell.vue?vue&type=template&id=1bd2a4b0"
import script from "./FpuiTableCell.vue?vue&type=script&lang=js"
export * from "./FpuiTableCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__